import { getAudioHighlightMetadata } from '@modules/feedback/components/AudioType/utils';
import {
  Feedback,
  FeedbackContentType,
  FeedbackLabel,
} from 'v2/core/entities/feedback';

interface GetHighlightMetadataOptions {
  feedback: Feedback;
  selectedLabels: FeedbackLabel[];
}

export const getHighlightMetadata = ({
  feedback,
  selectedLabels,
}: GetHighlightMetadataOptions) => {
  if (feedback.content.type !== FeedbackContentType.Audio) {
    return [];
  }

  return getAudioHighlightMetadata(
    selectedLabels,
    feedback.labels ?? [],
    feedback.content.audioConversationEn,
  );
};
